import { ModuleWithProviders, NgModule, Provider } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { ApiFacade } from "./+state/facades";
import { ApiInterceptor } from "./+state/interceptors";
import { ApiService, ApiSocketService } from "./+state/services";
import { API_CONFIG_TOKEN, ApiConfig } from "./providers";

@NgModule({
  imports: [CommonModule],
  providers: [ApiFacade, ApiService]
})
export class ApiDataAccessModule {
  static forRoot(config: ApiConfig): ModuleWithProviders<ApiDataAccessModule> {
    let services: Provider[] = [];

    if (config.socketUrl) {
      services = [ApiSocketService, ...services];
    }

    return {
      ngModule: ApiDataAccessModule,
      providers: [
        services,
        {
          provide: API_CONFIG_TOKEN,
          useValue: config
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ApiInterceptor,
          multi: true
        }
      ]
    };
  }
}
